import { createReducer, on } from '@ngrx/store';
import * as Action from '../actions/estate.action';
export type initialEstateType = {
    estateData: {
        land: any[];
        building: any[];
        condo: any[];
        ownerToken: string
    };
};
export let initialState: initialEstateType = {
    estateData: {
        land: [],
        building: [],
        condo: [],
        ownerToken: ''
    },
};
const _EstateReducer = createReducer(
    initialState,
    on(Action.SetEstate, (state, action) => {
        return {
            ...state,
            estateData: action.estateData,
        };
    }),
    on(Action.ResetEstate, () => {
        return {
            estateData: {
                land: [],
                building: [],
                condo: [],
                ownerToken: ''
            },
        };
    })
);
export function estateReducer(state, action) {
    return _EstateReducer(state, action);
}
